/**
 * 存储token
 * @param token token信息
 */
export function clearToken() {
  localStorage.removeItem('token');
}

/**
 * 存储token
 * @param token token信息
 */
export function setToken(token: string) {
  localStorage.setItem('token', token);
}

/**
 * 获取token信息
 */
export function getToken() {
  return localStorage.getItem('token') || '';
}
/**
 * 获取token信息
 */
export function getCompanyId() {
  return localStorage.getItem('companyId');
}

export function getSysRoleId() {
  return localStorage.getItem('sysRoleId');
}
export function setCompanyId(companyId?: string) {
  if (companyId) {
    localStorage.setItem('companyId', companyId);
  } else {
    localStorage.removeItem('companyId');
  }
}

export function setSysRoleId(sysRoleId?: string) {
  if (sysRoleId) {
    localStorage.setItem('sysRoleId', String(sysRoleId));
  } else {
    localStorage.removeItem('sysRoleId');
  }
}

export function setCurrency(currency: string) {
  localStorage.setItem('currency', currency);
}
export function getCurrency() {
  return localStorage.getItem('currency') || 'RMB';
}
/**
 * 获取token信息
 */
export function getTokenInfo() {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) {
    return {};
  }
  const [, payload] = tokenString.split('.');
  if (!payload) {
    return {};
  }
  try {
    return JSON.parse(Buffer.from(payload, 'base64').toString());
  } catch (error) {
    return {};
  }
}

export function getGlobalData() {
  const merchantStr = localStorage.getItem('merchant');
  const powersStr = localStorage.getItem('powers');

  const userInfo = getTokenInfo();
  return {
    currentAdmin: userInfo,
    merchant: JSON.parse(merchantStr || '{}'),
    powers: JSON.parse(powersStr || '{}'),
  };
}

/**
 * 从token中获取用户id
 */
export function getUserId() {
  return getTokenInfo().userId;
}

/**
 * 判断登陆态
 */
export function isLogin() {
  const res = getTokenInfo();
  if (res && res.exp * 1000 > Date.now() + 60 * 1000) {
    if (res.exp * 1000 < Date.now() + 60 * 60 * 1000) {
      // token时间不足一小时重新获取一次token
      // refreshToken();
    }
    return true;
  }
  return false;
}

/**
 * 获取 utmChannel
 */
export function getUtmChannel() {
  return localStorage.getItem('utmChannel');
}

/**
 * 存储 utmChannel
 */
export function setUtmChannel(utmChannel?: string) {
  if (utmChannel) {
    localStorage.setItem('utmChannel', utmChannel);
  } else {
    localStorage.removeItem('utmChannel');
  }
}
